
  

  <div class="page-padding" style="padding: 24px;">
    <div class="panel">
        <div class="panel__header">
            <span class="panel__header__title">{{'Equipment Setup' | translate | async}}</span>
        </div>
        <div class="panel__content center-content" *ngIf="setupComplete" [@fadeInOut]>
          <div class="setup-complete-container">
            <div class="setup-complete__header">{{'Setup Complete!' | translate | async}}</div>
            <i class="material-icons large-check">check_circle</i>
            <div class="set-complete__sub-header">{{'Now that you have setup your equipment, you need to setup implements for it before you can start recording inspections.' | translate | async}} </div>
            <div class="button-container">
              <button mat-raised-button color="warn" (click)="navigateToSetupImplements()">{{"Setup Implements for This Equipment" | translate | async}}</button>
              <button mat-raised-button (click)="navigateToSetupNewEquipment()">{{"Setup Another Equipment" | translate | async}}</button>
              <!--<button mat-raised-button (click)="navigateToManageEquipment()">Manage This Equipment</button>-->
            </div>
          </div>
        </div>


  <mat-horizontal-stepper *ngIf="!setupComplete" [linear]="true" [selectedIndex]="currentStep" #stepper>
    <mat-step>
      <ng-template matStepLabel>{{'Select Customer & Job Site' | translate | async}}</ng-template>
      <div class="step-container">
        <div class="margin-b--16">
          <b>{{'Would you like to setup a new equipment or modify an existing one?' | translate | async}}</b>
        </div>
        <div class="margin-bottom-24">
          <mat-radio-group [(ngModel)]="newOrExistingOption" ngDefaultControl>
            <mat-radio-button [value]="1" (click)="onNewEquipment()">{{'Setup New Equipment' | translate | async}}</mat-radio-button>
            <mat-radio-button [value]="2" (click)="onSelectEquipment()">{{'Modify Existing Equipment' | translate | async}}</mat-radio-button>
          </mat-radio-group>
          <div *ngIf="newOrExistingOption == 2" class="existing-info" [@fadeInOut] style="margin-top: 8px;">
            You can only change the SMU, LTD and Date of an existing equipment if there have been NO inspections performed, or implements setup on it. 
          </div>
        </div>
        <div class="input-group-description" *ngIf="newOrExistingOption == 1" [@fadeInOut]>
          {{'Please select the customer and job site where this equipment is located.' | translate | async}}
        </div>
        <div class="input-group-description" *ngIf="newOrExistingOption == 2" [@fadeInOut]>
          <b>{{'Please select the equipment' | translate | async}}</b>
        </div>
        <div class="margin-bottom-24">
          <div class="input-container">
            <label for="customer" class="label">{{'Customer' | translate | async}}</label>
            <select id="customer" placeholder="Select Customer" [(ngModel)]="selectedCustomer" (change)="loadJobsitesForCustomer()" class="get-Input"
              ngDefaultControl required>
              <option [value]="customer.Id" *ngFor="let customer of customerList">
                {{customer.Name}}
              </option>
            </select>
          </div>
          <div class="input-container">
            <label for="jobsite" class="label">{{'Job Site' | translate | async}}</label>
            <select id="jobsite" placeholder="Select Job Site"  class="get-Input" [(ngModel)]="selectedJobsite" (change)="loadEquipmentForJobsite()" ngDefaultControl required>
              <option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
                {{jobsite.Name}}
              </option>
            </select>
          </div>
          <div class="input-container" *ngIf="newOrExistingOption != 1" [@fadeInOut]>
            <label for="equipment" class="label">{{'Equipment' | translate | async}}</label>
            <select id="equipment" placeholder="Serial / Unit Number"  class="get-Input" [(ngModel)]="selectedEquipment" ngDefaultControl required (change)="onSelectEquipment()">
              <option [value]="equipment.Id" *ngFor="let equipment of equipmentList">
                {{equipment.SerialNumber}} : {{equipment.UnitNumber}}
              </option>
            </select>
          </div>
        </div>
        <div>
          <button mat-raised-button color="warn" (click)="goToStep(1)" [disabled]="loadingExistingEquipment" [class.loading]="loadingExistingEquipment">{{'Next' | translate | async}}</button>
        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{'Equipment Details' | translate | async}}</ng-template>
      <div class="step-container">
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'How do you identify this equipment?' | translate | async}}</div>
          <div class="input-container">
            <label class="label" for="serialNumber">{{'Serial Number' | translate | async}}</label>
            <input id="serialNumber" placeholder="{{'Serial Number' | translate | async}}" class="get-Input"  type="text" [(ngModel)]="serialNumber" (blur)="validateSerialAndUnit()" ngDefaultControl required>
          </div>
          <div class="input-container">
            <label class="label" for="unitNumber">{{'Unit Number' | translate | async}}</label>
            <input id="unitNumber" placeholder="{{'Unit Number' | translate | async}}"  class="get-Input" type="text" [(ngModel)]="unitNumber" (blur)="validateSerialAndUnit()" ngDefaultControl required>
          </div>
          <div class="red-text" *ngIf="!serialUnitValid">This equipment serial number and unit number combination is taken. You must enter a unique combination. </div>
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'What type of equipment is this?' | translate | async}}</div>
          <div class="input-container">
            <label class="label" for="make">{{'Make' | translate | async}}</label>
            <select id="make" placeholder="Select Make" class="get-Input"  [(ngModel)]="selectedMake" (change)="loadModelsForMake()" ngDefaultControl required>
              <option [value]="make.Id" *ngFor="let make of makeList">
                {{make.Name}}
              </option>
            </select>
          </div>
          <div class="input-container">
            <label class="label" for="model">{{'Model' | translate | async}}</label>
            <!-- <select id="model" placeholder="Select Model"  class="get-Input" [(ngModel)]="selectedModel" (change)="loadFamilyNameForModel()" ngDefaultControl required>
              <option [value]="model.Id" *ngFor="let model of modelList">
                {{model.Name}}
              </option>
            </select> -->

            <mat-form-field>
              <input type="text" (input)="changedModel($event)" matInput required
                [matAutocomplete]="auto" [(ngModel)]="machineModel">
              <mat-autocomplete [(ngModel)]="modelTitle" #model_auto="ngModel" #auto="matAutocomplete" required ngDefaultControl
                (optionSelected)="onSelcetionModel($event.option)">
                <mat-option [value]="model.Name" *ngFor="let model of modelList ">
                  {{model.Name}}
                </mat-option>
              </mat-autocomplete>
            </mat-form-field>
          </div>
          <!-- {{familyName}} -->
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'What is the earliest known SMU/Hourmeter and the date of reading for this equipment?' | translate | async}}</div>
          <div class="input-container">
            <label for="smu" class="label">{{'SMU at Setup' | translate | async}}</label>
            <input id="smu" placeholder="{{'SMU at Setup' | translate | async}}" type="number" class="get-Input" [(ngModel)]="smuAtSetup" (blur)="validateSmuAndLtd()" ngDefaultControl required [disabled]="!canChangeHoursAndDate">
            <span class="input-icon get-icon">{{'Hours' | translate | async}}</span>
          </div>
          <div class="input-container">
            <label for="bcm" class="label">{{'BCM at Setup' | translate | async}}</label>
            <input id="bcm" placeholder="{{'BCM at Setup' | translate | async}}" type="number" class="get-Input" [(ngModel)]="bcmAtSetup"  ngDefaultControl >
            <span class="input-icon get-icon">m³</span>
          </div>
          <div class="input-container">
            <label for="ton" class="label">{{'Tonnage at Setup' | translate | async}}</label>
            <input id="ton" placeholder="{{'Tonnage at Setup' | translate | async}}" type="number" class="get-Input" [(ngModel)]="tonAtSetup"  ngDefaultControl >
            <span class="input-icon get-icon">{{'Tons' | translate | async}}</span>
          </div>


          <div class="input-container">
            <label class="label" for="ltdAtSetup">{{'LTD at Setup' | translate | async}}</label> 
            <input id="ltdAtSetup" placeholder="{{'LTD at Setup' | translate | async}}" class="get-Input"  type="number" [(ngModel)]="ltdAtSetup" (blur)="validateSmuAndLtd()" ngDefaultControl required [disabled]="!canChangeHoursAndDate">
            <span class="input-icon get-icon">{{'Hours' | translate | async}}</span>
          </div>
          <div (click)="canChangeHoursAndDate ? picker.open() : null" class="input-container input-container--date">
            <label class="label">{{'Date of Reading' | translate | async}}</label>
            <input [matDatepicker]="picker" placeholder="{{'Date of Reading' | translate | async}}" class="get-Input-date" [(ngModel)]="dateOfReading" [disabled]="!canChangeHoursAndDate">
            <span class="input-icon get-date-icon" (click)="picker.open()"><i class="material-icons">date_range</i></span>
            <mat-datepicker #picker></mat-datepicker>
          </div>
          <div class="red-text" *ngIf="!smuLtdGreaterThanZero">The meter reading (SMU) and life to date (LTD) must be greater than 0. </div>
          <div class="red-text" *ngIf="!ltdGreaterThanSmu">The life to date (LTD) of the equipment cannot be less than the SMU. </div>
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'You can attach a photo of this equipment which can be seen throughout the application.' | translate | async}}</div>
          <input type='file' (change)="onSelectEquipmentPhoto($event)">
          <div style="margin-top: 8px;">
            <img *ngIf="imageUrl" [src]="imageUrl" height="300">
          </div>
        </div>
        <div>
          <button mat-raised-button (click)="goBackStep()">{{'Back' | translate | async}}</button>
          <button mat-raised-button color="warn" (click)="goToStep(2)">{{'Next' | translate | async}}</button>
        </div>
      </div>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{'Additional Information' | translate | async}}</ng-template>
      <div class="step-container">
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'On average how many days is this equipment in use, and on which days?' | translate | async}}</div>
          <div class="input-container">
            <label class="label" for="hoursPerDay">{{'Hours of Use' | translate | async}}</label>
            <input id="hoursPerDay" value="0" type="number" class="get-Input" [(ngModel)]="hoursUsePerDay" ngDefaultControl required>
            <span class="input-icon get-icon">{{'Per Day' | translate | async}}</span>
          </div>
          <div style="padding: 24px;">
            <mat-checkbox class="margin-right-16" [(ngModel)]="monCheck" ngDefaultControl>{{'Mon' | translate | async}}</mat-checkbox>
            <mat-checkbox class="margin-right-16" [(ngModel)]="tueCheck" ngDefaultControl>{{'Tue' | translate | async}}</mat-checkbox>
            <mat-checkbox class="margin-right-16" [(ngModel)]="wedCheck" ngDefaultControl>{{'Wed' | translate | async}}</mat-checkbox>
            <mat-checkbox class="margin-right-16" [(ngModel)]="thuCheck" ngDefaultControl>{{'Thu' | translate | async}}</mat-checkbox>
            <mat-checkbox class="margin-right-16" [(ngModel)]="friCheck" ngDefaultControl>{{'Fri' | translate | async}}</mat-checkbox>
            <mat-checkbox class="margin-right-16" [(ngModel)]="satCheck" ngDefaultControl>{{'Sat' | translate | async}}</mat-checkbox>
            <mat-checkbox [(ngModel)]="sunCheck" ngDefaultControl>{{'Sun' | translate | async}}</mat-checkbox>
          </div>
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'How often will you be inspecting this equipment? We will use this to help forecast future inspections.' | translate | async}} </div>
          <div class="input-container">
            <label for="inspectEvery" class="label">{{'I will inspect every' | translate | async}}</label>
            <input id="inspectEvery"  class="get-Input" palceholder="0" type="number" [(ngModel)]="inspectEvery" ngDefaultControl required>
            <select class="input-icon" [(ngModel)]="selectedInspectEveryUnit" class="get-Input" ngDefaultControl required>
              <option [value]="unit.Id" *ngFor="let unit of unitList">
                {{unit.Name}}
              </option>
            </select>
          </div>
        </div>
        <div class="margin-bottom-24">
          <div class="input-group-description">{{'You can also set some aditional details, although this is not required.' | translate | async}}</div>
          <div class="input-container">
            <label class="label" for="application">{{'Application' | translate | async}}</label>
            <select id="application" placeholder="Application" [(ngModel)]="selectedApplication" ngDefaultControl class="get-Input">
              <option [value]="application.Id" *ngFor="let application of applicationList">
                {{application.Name}}
              </option>
            </select>
          </div>
          <div class="input-container">
            <label class="label" for="ranking">{{'Ranking' | translate | async}}</label>
            <select id="ranking" placeholder="Ranking" [(ngModel)]="selectedRanking" ngDefaultControl class="get-Input">
              <option [value]="ranking.Id" *ngFor="let ranking of rankingList">
                {{ranking.Name}}
              </option>
            </select>
          </div>
          <div class="input-container">
            <label class="label" for="status">{{'Status' | translate | async}}</label>
            <select id="status" placeholder="Machine Status" [(ngModel)]="selectedStatus" ngDefaultControl class="get-Input">
              <option [value]="status.Id" *ngFor="let status of statusList">
                {{ status.Name }}
              </option>
            </select>
          </div>
          <div class="input-container">
            <label class="label" for="forecast">{{'Advanced Forecasting' | translate | async}}</label>
            <select id="forecast" placeholder="Forecasting" [(ngModel)]="selectedForecast" ngDefaultControl class="get-Input">
              <option [value]="forecast.Id" *ngFor="let forecast of forecastingList">
                {{ forecast.Name }}
              </option>
            </select>
          </div>
        </div>
        <div>
          <button mat-raised-button [disabled]="creatingEquipment" (click)="goBackStep()">{{'Back' | translate | async}}</button>
          <button mat-raised-button *ngIf="newOrExistingOption == '2'" [disabled]="updatingEquipment" [class.loading]="updatingEquipment" (click)="onUpdateEquipmentClick()" color="warn">{{'Update Equipment' | translate | async}}</button>
          <button mat-raised-button *ngIf="newOrExistingOption == '1'" [disabled]="creatingEquipment" [class.loading]="creatingEquipment" (click)="onCreateNewEquipmentClick()" color="warn">{{'Create Equipment' | translate | async}}</button>
        </div>
      </div>
    </mat-step>
  </mat-horizontal-stepper>
</div>
</div>
